<template>
    <div class="min_box">
      <div class="seachList"><span class="name">时间：</span>
        <a-range-picker class="seachs" v-model="search.submit_time" @change="changeDate()"  :allowClear="true" :showTime="false"  format="YYYY-MM-DD"/>
      </div>
      <div class="search-group flex">
      </div>
        <div class="canvas">
          <div class="flex">
            <div class="item" style="width:43%">
              <div>
                <p style="font-weight: bold">{{datas.orderMoney.num}}美元</p>
                <h1>总金额</h1>
              </div>
              <CakeChart :key="`orderMoneyKey`"  :data="datas.orderMoney.data"  id="orderMoneyTs"></CakeChart></div>
            <div class="item" style="width:43%">
              <div>
                <p style="font-weight: bold">{{datas.orderNum.num}}</p>
                <h1>企业数量</h1>
              </div>
              <CakeChart :key="`orderNumKey`" :data="datas.orderNum.data"  id="orderNumTs"></CakeChart>
            </div>
          </div>
        </div>
       <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id" @change="handleChange" :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"  >
         <span slot="action" slot-scope="text, record"> <a @click="details(text.a_customer_id)">查看</a></span>
        </a-table>

    </div>
</template>

<script>
    import Seach from "../../components/seach"
    import CakeChart from "../../components/cakeChart"
    import API from "./api";
    import moment from "moment"
    const columns = [
        {
            title: "客户名称",
            key: "company",
            ellipsis: true,
            dataIndex: "company",
        },
        {
            title: "邮箱",
            key: "email",
            ellipsis: true,
            dataIndex: "email",
        },
        {
            title: "行业",
            key: "industry_name",
            ellipsis: true,
            dataIndex: "industry_name",
        },
        {
            title: "县区",
            key: "erp_area_xian_text",
            ellipsis: true,
            dataIndex: "erp_area_xian_text",
        },{
        title: "上线日期",
        key: "erp_activation_time_text",
        ellipsis: true,
        dataIndex: "erp_activation_time_text",
      },{
        title: "到期日期",
        key: "erp_expire_time_text",
        ellipsis: true,
        dataIndex: "erp_expire_time_text",
      },{
        title: "订单数量",
        key: "order_num",
        ellipsis: true,
        dataIndex: "order_num",
      },{
        title: "金额（美元）",
        key: "order_money",
        ellipsis: true,
        dataIndex: "order_money",
        sorter: true,
      },{
        title: "操作",
        key: "action",
        scopedSlots: {customRender: "action"}
      }
    ];
    export default {
        name: "index",
        data(){
            return{
              orderMoneyKey:new Date().getDate(),
              orderNumKey:new Date().getDate(),
                num:"2",
                id: this.$route.query.id,
                datas:{
                  orderMoney:{data:[],num:''},
                  orderNum:{data:[],num:''},
                },
                data:[] ,
                list:[],
                selectedRowKeys:[],
                ids:"sourcea",
                columns,
                search:{
                  submit_time:[],
                  order:"",
                  type:1
                },
                page:"",
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
            }
        },
        components:{Seach,CakeChart},
        created() {
            this.$store.state.adminleftnavnum = "DataStatistics/AOrderStatisticsTS"; //设置左侧导航2-2 active
        },
        computed: {
            hasSelected() {
                return this.selectedRowKeys.length > 0;
            },
        },
        methods:{
          changeDate(){
            this.getList(1)
            this.getDetail()
          },
            handleChange(pagination, filters, sorter) {
                // this.filteredInfo = filters;
                // this.sortedInfo = sorter;
              if (this.search.submit_time.length > 0) {
                this.search.submit_time[0] = moment(this.search.submit_time[0]).format('YYYY-MM-DD')
                this.search.submit_time[1] = moment(this.search.submit_time[1]).format('YYYY-MM-DD')
              }
                if(sorter.order) {
                    let sort=sorter.order=="ascend"?"1":"2"
                    this.search.order=sort
                }else{
                    delete this.search.order
                    delete this.search.order
                }
                let seachData = JSON.parse(JSON.stringify(this.search))
                this.name=this.search.name
                API.service.GET_LIST({page: this.page || 1, ...seachData}).then(res => {
                    this.data = res.data.data.data
                    this.pagination.total=res.data.data.total
                    this.pagination.pageSize=res.data.data.per_page
                    this.pagination.current=res.data.data.current_page
                    this.selectedRowKeys=[]
                    this.loading = false
                })
            },
            getDetail() {
              if (this.search.submit_time.length > 0) {
                this.search.submit_time[0] = moment(this.search.submit_time[0]).format('YYYY-MM-DD')
                this.search.submit_time[1] = moment(this.search.submit_time[1]).format('YYYY-MM-DD')
              }
                API.service.RATE_PIE(this.search).then(res => {
                  this.datas.orderMoney={data:res.data.data.order_money,num:res.data.data.total_money}
                  this.datas.orderNum={data:res.data.data.order_num,num:res.data.data.total_num}
                  this.orderMoneyKey=new Date().getDate()
                  this.orderNumKey=new Date().getDate()
                })
            },
            exportList(){
                let seachData = JSON.parse(JSON.stringify(this.search))
                API.service.EXPORT({ids:this.selectedRowKeys ,page:this.page, ...seachData}).then(res => {
                    window.open( `${this.$store.state.urlExper}${res.data.data.path.substr(1)}`  )
                })
            },
            getList(page) {
                this.page=page
              if (this.search.submit_time.length > 0) {
                this.search.submit_time[0] = moment(this.search.submit_time[0]).format('YYYY-MM-DD')
                this.search.submit_time[1] = moment(this.search.submit_time[1]).format('YYYY-MM-DD')
              }
                let seachData = JSON.parse(JSON.stringify(this.search))
                this.name=this.search.name
                // console.log(seachData);
                API.service.GET_LIST({page: page || 1, ...seachData}).then(res => {
                    this.data = res.data.data.data
                    this.pagination.total=res.data.data.total
                    this.pagination.pageSize=res.data.data.per_page
                    this.pagination.current=res.data.data.current_page
                    this.selectedRowKeys=[]
                    this.loading = false
                })
            },
            onSelectChange(selectedRowKeys) {
                this.selectedRowKeys = selectedRowKeys;
            },
          details(id){
            this.$router.push({path: '/DataStatistics/AOrderStatisticsTSDetail', query: {id:id}})
          },
        },
        mounted() {
          this.$nextTick(() => {
            this.getDetail()
            this.getList()
          });

        }

    }
</script>

<style scoped>
    .title{font-weight: bold;font-size:18px;margin-bottom: 20px}
    .chart{margin-top:40px;width: 60%;position: relative;left: 10px}
    .list_box{border: 1px solid #f1f1f1;padding: 10px 16px;box-sizing: border-box;margin-top:40px;width: 38%}
    .list_box .list{line-height: 2;color: rgba(0, 0, 0, 0.65);width: 100%;}
    .list_box .top{border-bottom: 1px solid #f1f1f1;margin-bottom: 20px}
    .list_box .top i{color:#3a5a97}
    .list_box .title2{text-align: center;color: #3a5a97;font-weight: bold}
.canvas{margin: 40px 0}
    .search-group {
        float: right;
    }
    .search-group .ant-input {
        width: 200px;
        margin: 0 8px 0 0 ;
    }
    .search-group .search-input {
        width: 200px;height: 32px;
        margin: 0 8px 0 0 ;
    }
</style>
